import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { setRootCSSTheme } from '@/Poker/utils/fontFamily.js';
import { Provider } from 'react-redux';
import store from '@/Poker/redux/store.js';

// Set the font family based on environment
setRootCSSTheme();

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>
);

registerServiceWorker();

// Register the service worker for offline support and caching
async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    // set to the subdirectory from env for the service worker path
    const serviceWorkerBasePath = import.meta.env.VITE_REACT_APP_CLIENT_URL_PATH_NAME || '/';

    // Ensure trailing slash for safety under any unexpected edits
    const basePath = serviceWorkerBasePath.endsWith('/') ? serviceWorkerBasePath : serviceWorkerBasePath + '/';
    const serviceWorkerPath = `${basePath}service-worker.js`;
    try {
      const registration = await navigator.serviceWorker.register(serviceWorkerPath);
      console.log('Service Worker registered with scope:', registration.scope);
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }
}
